import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';

import {TrustpilotRatingType} from '../types/types';

/**
 * method gets the query to the trustpilot api
 *
 * @returns {Promise<TrustpilotRatingType>} a promise with rating from trustpilot api
 */
export const fetchTrustpilotRating = async (): Promise<TrustpilotRatingType> => {
    try {
        const response = await apiConfig.instanceGusaBackend.request({
            baseURL: '/',
            method: 'GET',
            url: ENDPOINTS.FETCH_TRUSTPILOT_RATING,
        });

        return response.data;
    } catch (error) {
        const [currentError] = error?.response?.data?.messages?.error || [
            {message: 'Something went wrong.'},
        ];

        throw new Error(`Trustpilot error: ${currentError.message}`);
    }
};
